const DefaultFieldValue = (field) => {
    switch (field.options.type) {
        case 'textbox': return { value: '' };
        case 'email': return { value: '' };
        case 'textarea': return { value: '' };
        case 'number': return { value: 0 };
        case 'currency': return { value: 0.00 };
        case 'datetime': return { value: null };
        case 'upload': return { value: 0, file: null };
        case 'userselect': return { value: [], users: [] };
        case 'options': return { value: field.options.options[0]}
        case 'checkbox': return { value: false };
        case 'paymentform': return { value: null };
        default: return false;
    }
}

export default DefaultFieldValue
